//@ts-nocheck

// Import Swiper
import Swiper, { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import AOS from "aos";
// import "aos/dist/aos.css";

// Import components
import SplitText from "../components/SplitText";
import { BotellasBanners } from "../components/animateBotellasBanner";

import "../../sass/pages/_home.scss";

window.addEventListener("load", () => {
  BotellasBanners();
  sliderBannerHome();
  sliderCervezasHome();
  sliderCervezasHomePremiadas();
  setupSplits();
  animateImage();
  //AOS.init();
  AOS.init({ once: 'true'});
});

const sliderBannerHome = () => {
  const swiper = new Swiper(".sliderBanner", {
    loop: false,
    slidesPerView: "auto",
    spaceBetween: 0,

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next--homeBanner",
      prevEl: ".swiper-button-prev--homeBanner",
    },
    modules: [Navigation],
  });
};

const sliderCervezasHome = () => {
  const swiper = new Swiper(".sectionSliderCervezas--container", {
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    modules: [Navigation],
  });
};

const sliderCervezasHomePremiadas = () => {
  const swiper = new Swiper(".sectionPremiadas--productos", {
    slidesPerView: 1.1,
    spaceBetween: 0,
    breakpoints: {
      913: {
        slidesPerView: 3,
      },
    },
  });
};

const animateImage = () => {
  gsap.registerPlugin(ScrollTrigger);
  gsap.from(".sectionHistoria--banner img", {
    ease: "power1",
    translateY: 160,
    translateX: -120,
    rotate: -20,
    duration: 2,
    scrollTrigger: {
      trigger: ".sectionHistoria--banner",
      start: "top center",
      //markers: true,
      id: `imgHistoria`,
      toggleActions: "play none none none",
    },
  });
};

const setupSplits = () => {
  new SplitText(".sectionPubsBodega--info .text_24");
  new SplitText(".sectionHistoria--info .text_24");
  new SplitText(".sectionTapit--tapit--text .text_16");
};

let text = document.querySelector("#block-co-bbc-page-title") as any;
if (text) {
  text.innerHTML = "";
}
